/**
 * Struttura di una categoria di menu
 * {
 *   items: [
 *     {
 *       name: String //Nome dell'opzione,
 *       external: Boolean //Il link è interno all'applicazione o esterno
 *       icon: String //Icona del pulsante
 *       iconHover: String, //Icon del pulsante colorata su hover
 *       description: String //Etichetta per hover e menu aperto
 *       href: String //Link di navigazione
 *       selectId: String //Etichetta per mostrare che è stata selezionata questa opzione
 *     },
 *     ...
 *   ]
 * }
 */

export default {
  namespaced: true,
  state: {
    selected: "",
    menuCategories: [],
    customMode: false,
    customWork: null,
  },
  getters: {
  },
  mutations: {
    setCustomMode: (state, data) => {
      state.customMode = true;
      state.customWork = data;
    },
    setSelected: (state, toSelect) => {
      state.selected = toSelect;
    },
    setCategories: (state, categories) => {
      state.menuCategories = categories;
    },
    addCategories: (state, categories) => {
      categories.forEach(c => {
        state.menuCategories.push(c);
      });
    },
    setItemAction: (state, data) => {
      const categories = state.menuCategories.slice();
      categories.forEach(c => {
        const item = c.items.find(i => i.name === data.name);
        if(item) {
          item.custom = true;
          item.customAction = data.action;
        }
      });
    },
    unsetItemAction: (state, name) => {
      const categories = state.menuCategories.slice();
      categories.forEach(c => {
        const item = c.items.find(i => i.name === name);
        if(item) {
          item.custom = false;
          delete item.customAction;
        }
      });
    },
  },
  actions: {
    setCustomMode: ({ commit }, data) => {
      return new Promise(resolve => {
        commit("setCustomMode", data);
        resolve();
      });
    },
    setSelected: ({ commit }, toSelect) => {
      return new Promise(resolve => {
        commit("setSelected", toSelect);
        resolve();
      });
    },
    setCategories: ({ commit }, categories) => {
      return new Promise(resolve => {
        commit("setCategories", categories);
        resolve();
      });
    },
    addCategories: ({ commit }, categories) => {
      return new Promise(resolve => {
        commit("addCategories", categories);
        resolve();
      });
    },
    setItemAction: ({ commit }, data) => {
      return new Promise(resolve => {
        commit("setItemAction", data);
        resolve();
      });
    },
    unsetItemAction: ({ commit }, name) => {
      return new Promise(resolve => {
        commit("unsetItemAction", name);
        resolve();
      });
    }
  }
};
